var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"comp-body-wrapper"},[(_vm.showLoader)?_c('div',{staticClass:"loader-div"},[_c('div',{staticClass:"loader-image-circle"})]):_vm._e(),_c('Header'),_c('router-view'),(_vm.showNotePopUp)?_c('note-pop-up'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }